import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en_US.json';
import translationFA from './locales/fa_IR.json';
import translationAR from './locales/ar_EG.json';
import translationTR from './locales/tr_TR.json';

const resources = {
    en: {
        translation: translationEN,
    },
    fa: {
        translation: translationFA,
    },
    ar: {
        translation: translationAR,
    },
    tr: {
        translation: translationTR,
    }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', 
    fallbackLng: 'en', 
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
